import { NavigateFunction,} from "react-router-dom";

/**
 * Converts file size from bytes to megabytes.
 * @param fileSize - The size of file in bytes to be converted.
 * @returns The size to file in megabytes
 */
export const convertToMegabytes = (fileSize: number) => {
    const megabytes = fileSize / (1024 * 1024);
    return parseFloat(megabytes.toFixed(2));// 1 MB = 1024 * 1024 bytes
}

/**
 * Extract image name from image url
 * @param imageUrl - The path to image
 * @returns The name of the image only
 */
export const getImageName = (imageUrl: string): string => {
    const segments = imageUrl.split('/');
    return segments[segments.length - 1];
}

/**
* Adds an item to the list if it doesn't already exist in the list based on a comparison.
* @param list - The list to which the item should be added.
* @param item - The item to add to the list.
* @param compare - A function to compare the existing items in the list with the new item. 
*                      It should return true if the items are considered equal.
* @returns A new list containing unique items, including the newly added item if it was unique.
*/
export const addUniqueItem = (list: any[], item: any, compare: (a: any, b: any)=> boolean)  => {
  const exists = list.some(existingItem => compare(existingItem, item))
  if(!exists){
    return [...list, item]
  }
  return list

}

/**
 * Navigates back to the site materials section of the dashboard
 * @param navigate - The `NavigateFunction` instance used to perform the navigation.
 */
export const handleBackToSiteMaterial = (navigate: NavigateFunction) => {
  navigate("/admin/dashboard/", { state: { from: "blogposts" } })

}

// Function to get CSRF token from cookies
export const getCsrfToken =():string => {
  const name = 'csrftoken';
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || ""
  }
  else{
    return ""
  }
}
